import React from "react";
import PropTypes from "prop-types";

import { MyDraggable as Draggable } from "../../components/Core";
import HoverBar from "../../components/HoverBar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import { generateStyle, l, setOverLay } from "../../functions";
import Icon from "../../components/Icons";

import { connect } from "react-redux";
import isEqual from "lodash/isEqual";

const mapStateToProps = (state) => {
  return {
    currentLang: state.rootReducer.currentLang || 1,
    settings: state.rootReducer?.appearanceSettings || {},
  };
};

class ProductViewers extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProp, nextState) {
    if (
      !isEqual(this.props?.payload, nextProp?.payload) ||
      !isEqual(this.props?.settings, nextProp?.settings)
    ) {
      return true;
    }

    return false;
  }
  _initViewers = () => {
    let { payload } = this.props;

    if (payload === null) payload = this.props.options.payload;

    let viewersLabel = "";
    if (payload.datas) {
      if (payload.datas["viewersLabel_" + this.props.currentLang])
        viewersLabel = payload.datas["viewersLabel_" + this.props.currentLang];
      else if (payload.datas["viewersLabel"])
        viewersLabel = payload.datas["viewersLabel"];
    }

    const { viewersNumber, viewersTextColor, viewersBgColor } =
      payload.datas || { viewersNumber: [0, 2000] };

    const cssSettings = generateStyle(payload, "container");
    const cssSettingsText = generateStyle(payload, "text", "body");
    const cssAlignment = generateStyle(payload, "alignment");

    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        {setOverLay(payload)}
        <Row>
          <Col xs={12} className="fullcol">
            <div style={cssAlignment}>
              <div className="people-view" style={cssSettingsText}>
                <span
                  style={{
                    color: viewersTextColor,
                    backgroundColor: viewersBgColor,
                  }}
                >
                  {(viewersNumber && viewersNumber[0]) || 123}
                </span>{" "}
                {viewersLabel}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      datas,
      ...rest
    } = this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initViewers()}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initViewers()}
      </Draggable>
    );
  }
}

ProductViewers.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ProductViewers);
